export const formats = {
  date: {
    angular: 'dd.MM.yyyy',
    moment: 'DD.MM.YYYY',
    isoMoment: 'YYYY-MM-DD',
    momentShort: 'DD.MM',
  },
  dateTime: {
    moment: 'DD.MM.YYYY HH:mm:ss',
    momentShort: 'DD.MM HH:mm',
    angular: 'dd.MM.yyyy H:mm:ss',
    angularShort: 'dd.MM H:mm',
    isoMoment: 'YYYY-MM-DD HH:mm:ss',
  },
  time: {
    moment: 'HH:mm',
    angular: 'H:mm',
  },
  month: {
    moment: 'MMM',
    momentLong: 'MMMM',
  },
  year: {
    momentLong: 'YYYY',
  },
};

export const snackBars = {
  durations: {
    default: 2000,
  },
};

export const languages = {
  cz: 'cz',
  en: 'en',
  sk: 'sk',
};

export const storage = {
  keys: {
    auth: 'auth',
    language: 'language',
    migration: 'migration',
    objects: 'objects',
    settings: 'settings',
    user: 'user',
  },
};

export const event = {
  types: {
    cloudUpdate: 'cloud:update',
  },
};

export const errors = {
  badCredentials: {
    code: 'error.badCredentials',
    message: 'Bad credentials',
  },
  forbidden: {
    code: 'error.forbidden',
    message: 'Forbidden',
  },
  noSession: {
    code: 'error.noSession',
    message: 'No session',
  },
  notFound: {
    code: 'error.notFound',
    message: 'Not found',
  },
  unauthorized: {
    code: 'error.unauthorized',
    message: 'Unauthorized',
  },
  unsupportedApiVersion: {
    code: 'error.unsupportedApiVersion',
    message: 'Unsupported API version',
  },
  zoneNotFound: {
    code: 'error.zoneNotFound',
    message: 'Zone not found',
  },
};

export const routes = {
  dispatcher: {
    relativeUrl: '',
    url: '',
  },
  landing: {
    relativeUrl: 'landing',
    url: 'landing',
  },
  login: {
    relativeUrl: 'login',
    url: 'login',
  },
};

export const charts = {
  types: {
    verticalBar: 'verticalBar',
    horizontalBar: 'horizontalBar',
    pie: 'pie',
  },
  scales: {
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
  },
};

export const meters = {
  valueTypes: {
    l1Current: 'L1Current',
    l2Current: 'L2Current',
    l3Current: 'L3Current',
    l1Voltage: 'L1Voltage',
    l2Voltage: 'L2Voltage',
    l3Voltage: 'L3Voltage',
    l1Power: 'L1Power',
    l2Power: 'L2Power',
    l3Power: 'L3Power',
    powerTotal: 'PowerTotal',
    powerHz: 'PowerHz',
    energyTotal: 'EnergyTotal',
    volume: 'Volume',
    volume1: 'Volume1',
    volume2: 'Volume2',
    volumeFlow: 'VolumeFlow',
    voltage: 'voltage',
    current: 'current',
    power: 'power',
    energy: 'energy',
    battery: 'battery',
    linkquality: 'linkquality',
    t1: 'T1',
    t2: 'T2',
    consumption: 'Consumption',
  },
};
